import { useSafeState } from 'ahooks';
import React, {
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import Loading from '@/pages/intelligence/components/Loading';
import { useBase64ImageValidation } from '@/pages/aigc/hooks/useBase64ImageValidation';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
export const NoDataRefresh = ({
  hanldeRefreshPromise,
  refReshLoaidng,
  imgSrc,
}: {
  imgSrc: string;
  refReshLoaidng: boolean;
  children?: ReactNode;
  hanldeRefreshPromise: (...args: any[]) => void;
}): ReactElement => {
  // const { imageUrl } = useBase64ImageValidation(imgSrc);
  const { formatMessage, isEn } = useAigcIntl('dataAnalysis');
  const [isValid, setIsValid] = useState<boolean>(true);
  useEffect(() => {
    setIsValid(true);
  }, [imgSrc]);
  const hanldeRefresh = () => {
    hanldeRefreshPromise?.();
  };
  if (refReshLoaidng) return <Loading />;

  return (
    <div className="nodata-refresh">
      {isValid ? (
        <img
          src={`data:image/png;base64,${  imgSrc}`}
          alt=""
          onError={(e: any) => {
            setIsValid(false);
          }}
        />
      ) : (
        <>
          {formatMessage('no_data')}
          <span className="nodata-refresh-data" onClick={hanldeRefresh}>
            {formatMessage('refresh')}
          </span>
        </>
      )}
    </div>
  );
};
